import { Link } from "react-router-dom";
import { Logo } from "../../components/Logo";

export const GoogleButton = ({ label = "Continue with Google" }) => (
  <button
    data-testid="google-login-button"
    onClick={() => {
      // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
      const redirectUrl = window.location.origin + "/dashboard";
      window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    }}
    className="btn-outline w-full py-2.5 text-sm flex items-center justify-center gap-2"
  >
    <svg width="16" height="16" viewBox="0 0 24 24">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z" />
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z" />
      <path fill="#FBBC05" d="M5.84 14.1A6.6 6.6 0 0 1 5.49 12c0-.73.13-1.44.35-2.1V7.06H2.18A11 11 0 0 0 1 12c0 1.77.43 3.45 1.18 4.94l3.66-2.84z" />
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15A11 11 0 0 0 12 1 11 11 0 0 0 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z" />
    </svg>
    {label}
  </button>
);

export const AuthShell = ({ title, subtitle, children }) => (
  <div className="min-h-screen bg-[#050505] grid-noise flex items-center justify-center px-4 py-12">
    <div className="w-full max-w-md fade-up">
      <Link to="/" data-testid="auth-logo-link" className="flex justify-center mb-8">
        <Logo size={64} />
      </Link>
      <div className="card-dark p-8">
        <h1 className="font-display text-2xl text-white mb-1">{title}</h1>
        <p className="text-sm text-gray-500 mb-6">{subtitle}</p>
        {children}
      </div>
      <p className="text-center text-xs text-gray-600 mt-6 leading-relaxed">
        ChartzFx never holds your funds. Capital always remains in your own broker account.
      </p>
    </div>
  </div>
);
